export const itemsContent = {
    en: {
        Details: 'Details',
        'Payment Details': 'Payment Details',
        Transaction: 'Transaction',
        'Reference number': 'Reference number',
        Order: 'Order',
        'Create Date': 'Create Date',
        'Last Update': 'Last Update',
        Status: 'Status',
        Amount: 'Amount',
        'Test Payment': 'Test Payment',
        'Refund Reference': 'Refund Reference',
        Refund: 'Refund',
        'Customer Details': 'Customer Details',
        Email: 'Email',
        Phone: 'Phone',
        'Billing Details': 'Billing Details',
        Name: 'Name',
        'Address Line': 'Address Line',
        City: 'City',
        'Postal Code': 'Postal Code',
        Country: 'Country',
        'Shipping Details': 'Shipping Details',
        'Refund Details': 'Refund Details',
        'Test Refund': 'Test Refund',
        'Payment Reference': 'Payment Reference',
        'Payment Processor': 'Payment Processor',
        'Details for': 'Details for',
        Close: 'Close',
        Search: 'Search',
        Payments: 'Payments',
        Refunds: 'Refunds',
        asc: 'asc',
        desc: 'desc',
        Sort: 'Sort',
        Filters: 'Filters',
        Settings: 'Settings',
        'No results found': 'No results found',
        'Try changing the filters or search': 'Try changing the filters or search',
    },
    fi: {
        Details: 'Lisätiedot',
        'Payment Details': 'Maksutiedot',
        Transaction: 'Transaktiotunniste',
        'Reference number': 'Viitenumero',
        Order: 'Tilauksen',
        'Create Date': 'Luontipäivä',
        'Last Update': 'Päivitetty viimeksi',
        Status: 'Tila',
        Amount: 'Summa',
        'Test Payment': 'Päivitetty viimeksi',
        'Refund Reference': 'Palautuksen viite',
        Refund: 'Palautus',
        'Customer Details': 'Asiakkaan tiedot',
        Email: 'Sähköposti',
        Phone: 'Puhelinnumero',
        'Billing Details': 'Laskutustiedot',
        Name: 'Nimi',
        'Address Line': 'Osoiterivi',
        City: 'Kaupunki',
        'Postal Code': 'Postinumero',
        Country: 'Maa',
        'Shipping Details': 'Toimitustiedot',
        'Refund Details': 'Tiedot palautuksesta',
        'Test Refund': 'Testipalautus',
        'Payment Reference': 'Maksun viite',
        'Payment Processor': 'Maksupalvelu',
        'Details for': 'Lisätiedot',
        Close: 'Sulje',
        Search: 'Haku',
        Payments: 'Maksut',
        Refunds: 'Palautukset',
        asc: 'nouseva',
        desc: 'laskeva',
        Sort: 'Järjestä',
        Filters: 'Suodattimet',
        Settings: 'Asetukset',
        'No results found': 'Ei tuloksia',
        'Try changing the filters or search': 'Kokeile muuttaa suodattimia tai hakua',
    },
    sv: {
        Details: 'Ytterligare information',
        'Payment Details': 'Betalningsuppgifter',
        Transaction: 'Transaktions',
        'Reference number': 'Referensnummer',
        Order: 'Order',
        'Create Date': 'Skapad',
        'Last Update': 'Senast uppdaterad',
        Status: 'Status',
        Amount: 'Summa',
        'Test Payment': 'Testbetalning',
        'Refund Reference': 'Returreferens',
        Refund: 'Retur',
        'Customer Details': 'Kundinformation',
        Email: 'E-mailadressen',
        Phone: 'Telefonnummer',
        'Billing Details': 'Faktureringsinformation',
        Name: 'Namn',
        'Address Line': 'Adressrad',
        City: 'Stad',
        'Postal Code': 'Postnummer',
        Country: 'Land',
        'Shipping Details': 'Leveransinformation',
        'Refund Details': 'Returneringsuppgifter',
        'Test Refund': 'Testreturnering',
        'Payment Reference': 'Betalningsreferens',
        'Payment Processor': 'Betalningsbehandlare',
        'Details for': 'Information om',
        Close: 'Stäng',
        Search: 'Sök',
        Payments: 'Betalnings',
        Refunds: 'Returneringar',
        asc: 'Stigande',
        desc: 'Nedåtgående',
        Sort: 'Sortera',
        Filters: 'Filter',
        Settings: 'Inställningar',
        'No results found': 'Inga resultat',
        'Try changing the filters or search': 'Prova att byta filter eller sök',
    },
};
